<template>
  <div>
    <b-card no-body class="mx-n3">
      <b-row>
        <b-col>
          <XtendHeatmap :url="urls.topProgramsUrl" :alertUrl="urls.processAlertsUrl" :timeRange="timeRange" />
        </b-col>
      </b-row>
      <b-row class="mx-1 mt-2 mb-1" align-h="between">
        <b-col lg="7" md="12" sm="12">
          <b-row align-h="between">
            <b-col lg="4" md="4" sm="12" class="mb-1">
              <div class="form-select">
                Show
                <b-form-select
                  v-model="perPage"
                  :options="options"
                  style="width: 60px;"
                  size="sm"
                ></b-form-select>
                Entries
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="5" md="12" sm="12" class="mb-1">
          <b-row align-h="end">
            <b-col cols="auto">
              <SearchBar :hasErrorMessage="true">
                <template #input>
                  <b-form-input v-model="filter" type="search" placeholder="Search" />
                </template>
              </SearchBar>
            </b-col>
            <b-col cols="auto">
              <ExportCsvButton :data="process" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div v-if="hasData">
            <b-table
              class="table-with-actions-min-height px-2"
              responsive
              striped
              outlined
              :items="processFilter"
              :fields="computedTableFields"
              :per-page="perPage"
              :current-page="currentPage"
              :filter="filter"
              @filtered="onFiltered"
              select-mode="single"
              selectable
            >
              <template #cell(userCount)="row">
                {{ formatNumberWithCommas(row.value) }}
              </template>
              <template #cell(executionCount)="row">
                {{ formatNumberWithCommas(row.value) }}
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="paginationTotalRows"
              :per-page="perPage"
              align="right"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mb-2 mx-1"
            />
          </div>
          <div v-else-if="loaded" class="mx-1 pl-1 mb-1">
            {{ $t("No Data Available") }}
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ExportCsvButton from '@/xvisor/components/ExportCsvButton.vue';
import SearchBar from '@/xvisor/components/SearchBar.vue';
import collapseText from '@/xvisor/utilities/collapseText';
import formatNumberWithCommas from '@/xvisor/utilities/addCommaToNumber';
import XtendHeatmap from '@/xvisor/components/xtend/Heatmap.vue';

export default {
  props: {
    timeRange: {
      type: Object,
      required: true,
    },
    urls: {
      type: Object,
      required: true,
    },
  },
  components: {
    ExportCsvButton,
    XtendHeatmap,
    SearchBar,
  },
  data() {
    return {
      url: this.urls.processCreationsUrl,
      process: [],
      loaded: false,
      currentPage: 1,
      perPage: 10,
      options: [
        { value: 5, text: '5' },
        { value: 10, text: '10' },
        { value: 15, text: '15' },
      ],
      filter: null,
      filteredLength: null,
      tableFields: [
        { key: 'processName', label: 'Process Name', sortable: true },
        { key: 'userCount', label: 'User Count', sortable: true },
        { key: 'executionCount', label: 'Execution Count', sortable: true },
        { key: 'parentProcess', label: 'Parent Process', sortable: true },
      ],
    };
  },
  computed: {
    hasData() {
      return this.loaded && this.process && this.process.length > 0;
    },
    paginationTotalRows() {
      if (this.filter) return this.filteredLength;
      return this.process.length;
    },
    computedTableFields() {
      return this.tableFields;
    },
    processFilter() {
      const retVal = this.process;
      return retVal;
    },
  },
  watch: {
    url() {
      this.httpGet();
    },
    timeRange() {
      this.httpGet();
    },
  },
  mounted() {
    this.httpGet();
  },
  methods: {
    httpGet() {
      this.loaded = false;
      this.$http
        .get(this.url, {
          params: {
            start: this.timeRange.start.toISOString(),
            end: this.timeRange.end.toISOString(),
          },
        })
        .then((response) => { this.process = response.data; })
        .finally(() => { this.loaded = true; });
    },
    onFiltered(filteredItems) {
      this.filteredLength = filteredItems.length;
      this.currentPage = 1;
    },
    collapseText,
    formatNumberWithCommas,
  },
};
</script>

<style scoped>
  .form-select{
    min-width: 160px;
    width: 20%;
  }
</style>
